// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h1-6";
export var emphasizeQuantity = "_h1-3";
export var flatBottomCorners = "_h1-5";
export var productImage = "_h1-0";
export var quantityContainer = "_h1-2";
export var tooltip = "_h1-1";
export var wrapAndEllipsesOverflow = "_h1-4";